module.exports = __webpack_public_path__ + "static/media/ecgQuestion.5bab72d9.mp3";